import * as Sentry from '@sentry/react';

// Client-side Sentry init. Vite exposes env vars prefixed `VITE_` at build
// time, so the deploy pipeline can inject VITE_SENTRY_DSN / VITE_SENTRY_RELEASE.
// Missing DSN → no-op (Sentry SDK accepts undefined and stays dormant).

const TRACES_SAMPLE_RATE_PROD = 0.1;

interface ClientEnv {
  readonly dsn?: string | undefined;
  readonly environment?: string | undefined;
  readonly release?: string | undefined;
  readonly mode: string;
}

function readEnv(): ClientEnv {
  const meta = import.meta.env as Record<string, string | undefined> & { MODE: string };
  return {
    dsn: meta['VITE_SENTRY_DSN'],
    environment: meta['VITE_SENTRY_ENVIRONMENT'],
    release: meta['VITE_SENTRY_RELEASE'],
    mode: meta.MODE,
  };
}

export function initClientSentry(): void {
  const env = readEnv();
  if (!env.dsn) return;
  Sentry.init({
    dsn: env.dsn,
    environment: env.environment ?? env.mode,
    ...(env.release ? { release: env.release } : {}),
    tracesSampleRate: env.mode === 'production' ? TRACES_SAMPLE_RATE_PROD : 1.0,
    sendDefaultPii: false,
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
